import lang from '@/lang/middleware/pages/accredited-by-cru';

export default ({ store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const description = store.$i18n.t('description');
  const title = store.$i18n.t('title');
  store.commit('jumbotron/SET_JUMBOTRON', { title, type: 'generic' });
  store.commit('pageContent/setHead', { description, title });
};
